import { render } from "./Simulation.vue?vue&type=template&id=e32f5ff2&scoped=true"
import script from "./Simulation.vue?vue&type=script&lang=js"
export * from "./Simulation.vue?vue&type=script&lang=js"

import "./Simulation.vue?vue&type=style&index=0&id=e32f5ff2&scoped=true&lang=css"
import "./Simulation.vue?vue&type=style&index=1&id=e32f5ff2&scoped=true&lang=css"
import "./Simulation.vue?vue&type=style&index=2&id=e32f5ff2&scoped=true&lang=css"
import "./Simulation.vue?vue&type=style&index=3&id=e32f5ff2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e32f5ff2"],['__file',"src/views/budget/Simulation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e32f5ff2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e32f5ff2', __exports__)) {
    api.reload('e32f5ff2', __exports__)
  }
  
  module.hot.accept("./Simulation.vue?vue&type=template&id=e32f5ff2&scoped=true", () => {
    api.rerender('e32f5ff2', render)
  })

}


export default __exports__